export default __webpack_public_path__ + "static/media/submit_active.28475d85.png";